import React from "react";
import { FeatureGroup, Popup } from "react-leaflet";
import { observer } from "mobx-react";
import { GeoZoneRecord, ZoneComponent } from "../model";
import {
    Button, Stack
} from "@mui/material";
import { useStore } from "../../../hooks/useStore";

export const GeozoneDrawing = observer(() => {
    const { geozones } = useStore();
    const { zones, isEditing, startEditGeoZone, deleteGeoZone } = geozones;

    if (isEditing) return null;

    const handleEditClick = (zoneId: GeoZoneRecord["id"]) => {
        startEditGeoZone(zoneId);
    };

    const handleDeleteClick = (zoneId: GeoZoneRecord["id"]) => {
        deleteGeoZone(zoneId)
    };

    return (
        <FeatureGroup>
            {zones.map((z) => {
                return (
                    <ZoneComponent key={z.id} zone={z.zone}>
                        <Popup>
                            <div>
                                <h2>{z.name}</h2>
                                <Stack direction="column" gap={1}>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => handleEditClick(z.id)}
                                    >
                                        Редактировать
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        color="error"
                                        onClick={() => handleDeleteClick(z.id)}
                                    >
                                        Удалить
                                    </Button>
                                </Stack>
                            </div>
                        </Popup>
                    </ZoneComponent>
                );
            })}
        </FeatureGroup>
    );
});
